var menu = {
    nav : null,
    btn : null,
    btnimg : null,
    links : null,
    header : null,

    close: (e) => {

        menu.nav.classList.remove("active");
        menu.btnimg.src = menu.btnimg.src.replace("close", "hamburger");
        let scroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        if (scroll > 30) {
            menu.header.classList.add("scroll");
        } else {
            menu.header.classList.remove("scroll");
        }

    },
    init: function() {
        menu.nav = helper.element(".nav", false);
        menu.btn = helper.element(".nav-btn", false);
        menu.btnimg = helper.element(".nav-btn-img", false);
        menu.links = helper.element(".nav-link", true);
        menu.header = helper.element("header");
        menu.pause = false

        if (menu.nav && menu.btn && menu.btnimg && menu.links && menu.header) {
            helper.event(menu.btn, "click touchstart", function(e) {
                if (!menu.pause) {
                    menu.pause = true;
                    if (menu.nav.classList.contains("active")) {
                        menu.close(e);
                    } else {
                        menu.nav.classList.add("active");
                        menu.btnimg.src = menu.btnimg.src.replace("hamburger", "close");
                        menu.header.classList.remove("scroll");
                    }
                    if (e.type === "touchstart") {
                        helper.delay(640).then(() => {
                            menu.pause = false;
                        });
                    } else {
                        menu.pause = false;
                    }

                }

            });


            helper.event(document.body, "keydown", function(e) {
                if (menu.nav.classList.contains("active") && e.key === "Escape" ) {
                    menu.close(e);
                }
            });

            let k = 0;
            Array.prototype.forEach.call(menu.links, item => {
                item.style.animationDelay = k + "s";
                k = k + .16;
            });
        }
    }
};